
import { Topbar as SharedTopbar, LanguageSelector } from "@rc-acs/shared/ui";

import { useAuthStore } from "@/hooks/useAuth";

import { useTheme, useI18n } from "@rc-acs/shared/ui";

import { Sun, Moon, LogOut } from "lucide-react";

import { Button } from "@rc-acs/shared/ui";

interface CoreTopbarProps {
  title: string;
  onMenuToggle: () => void;
}

export function Topbar({ title, onMenuToggle }: CoreTopbarProps) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useI18n();
  const logout = useAuthStore((s) => s.logout);

  const actions = (
    <>
      <div className="flex items-center gap-0.5 rounded-md border border-border bg-muted/30 px-1">
        <LanguageSelector />
        <div className="h-5 w-px bg-border" />
        <Button
          variant="ghost"
          size="icon"
          onClick={toggleTheme}
          aria-label={theme === "light" ? t("common.themeSwitchDark") : t("common.themeSwitchLight")}
        >
          {theme === "light" ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
        </Button>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => logout()}
        aria-label={t("common.logout")}
      >
        <LogOut className="h-4 w-4 mr-2" />
        <span className="hidden sm:inline">{t("common.logout")}</span>
      </Button>
    </>
  );

  return (
    <SharedTopbar
      title={title}
      actions={actions}
      onMenuToggle={onMenuToggle}
    />
  );
}
